import { StepType } from "../../../enums/course/step-type";
import { StepSubmissionExam } from "./step-submission-exam";

export declare class ExamAnswerSubmission {
  public type: StepType;
  public question: StepSubmissionExam;
  public file?: number;
  public text?: string;
}